import React from 'react';

import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PropTypes from 'prop-types';

import theme from 'src/theme';
import { formatPhonesNumbers } from 'src/utils/constants/clients';

const ResultBureauView = ({ name, phones }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        padding: { xs: '8px', md: '16px 32px 40px' }
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 600,
          width: '100%',
          borderRadius: '16px',
          border: '1px solid rgba(21, 55, 80, 0.12)',
          overflow: 'hidden'
        }}
      >
        {/* Colored header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: { xs: '28px 24px 24px', md: '36px 40px 30px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}
        >
          <Box
            sx={{
              width: 68,
              height: 68,
              borderRadius: '50%',
              backgroundColor: 'rgba(255,255,255,0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '16px'
            }}
          >
            <CheckCircleOutlineIcon sx={{ fontSize: 38, color: '#FFFFFF' }} />
          </Box>
          <Typography
            variant="h5"
            sx={{
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: { xs: '1.25rem', md: '1.4rem' },
              lineHeight: 1.3,
              marginBottom: '8px'
            }}
          >
            {t('BUREAU_FORM.RESULT.DEAR_USER').replace('{user}', name)}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '1rem' }}
          >
            {t('BUREAU_FORM.RESULT.THANKS_FOR_APPLYING')}
          </Typography>
        </Box>

        {/* Body */}
        <Box sx={{ padding: { xs: '24px', md: '32px 40px' } }}>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.primary,
              fontSize: '0.95rem',
              lineHeight: 1.7,
              marginBottom: '24px',
              textAlign: 'justify'
            }}
          >
            {(() => {
              const formattedPhone = formatPhonesNumbers(phones);
              const parts = t('BUREAU_FORM.RESULT.NEXT_STEP', {
                phone: '|||PHONE|||'
              }).split('|||PHONE|||');
              return (
                <>
                  {parts[0]}
                  <Box
                    component="span"
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.primary.main
                    }}
                  >
                    {formattedPhone}
                  </Box>
                  {parts[1]}
                </>
              );
            })()}
          </Typography>

          {/* Document requirement */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              backgroundColor: 'rgba(21, 55, 80, 0.05)',
              borderLeft: `3px solid ${theme.palette.primary.main}`,
              borderRadius: '0 8px 8px 0',
              padding: '16px 20px',
              marginBottom: '28px'
            }}
          >
            <ArticleOutlinedIcon
              sx={{
                fontSize: 20,
                color: theme.palette.primary.main,
                flexShrink: 0,
                marginTop: '2px'
              }}
            />
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
                fontWeight: 600,
                fontSize: '0.95rem',
                lineHeight: 1.5
              }}
            >
              {t('BUREAU_FORM.RESULT.DOCUMENTS.BANK_STATEMENT')}
            </Typography>
          </Box>

        </Box>
      </Paper>
    </Box>
  );
};
ResultBureauView.propTypes = {
  name: PropTypes.string,
  phones: PropTypes.array
};

export default ResultBureauView;
